export enum AssistitoEnums {
    Maschio=1,
    Fremminia=2
}